module.exports = __webpack_public_path__ + "img/stock0.783cba6a.png";